/**
 * 提交成功页面
 * @author PJ
 */
import {
  // Bridge,
} from '@/utils';
import { HeaderBar } from '@/components';

export default {
  data() {
    return {
      title: '提交成功',

      userPhone: '',
    };
  },

  components: {
    HeaderBar,
  },

  methods: {
    onGoHome() {
      this.$router.push({
        path: '/',
      });
    },

    onBack() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.userPhone = this.$store.state.userPhone;
  },
};



// WEBPACK FOOTER //
// ./src/pages/Application/components/SubmitSuccess/main.js